import { useState } from "react";
import Logo from "../assets/icons/logo.svg";
import Illustration from "../assets/icons/Illustration.svg";
import Input from "../components/partials/inputs";
import PrimaryBtn from "../components/partials/btn";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../data/stores/authStore";
import useGenFetcher, { apiCall } from "../data/useFetcher";
import useErrorStore from "../data/stores/errorStore";
import toast from "react-hot-toast";
import { Controller, useForm } from "react-hook-form";

interface FormType {
	email: string;
	password: string;
}

const Login = () => {
	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm({
		defaultValues: {
			password: "",
			email: "",
		},
	});

	const { login } = useAuthStore(),
		{ loadUser } = useGenFetcher(),
		navigate = useNavigate();

	const [loading, setLoading] = useState(null),
		{ returnErrors } = useErrorStore();
	let onSubmit = async (data: FormType) => {
		setLoading(true);

		let { response, errArr, errMsg } = await apiCall({
			type: "post",
			url: `/api/v1/auth/login`,
			data,
		});
		// console.log({ response, errArr, errMsg });
		if (errArr) {
			setLoading(false);
			return returnErrors(errArr);
		}
		if (errMsg) {
			setLoading(false);
			return toast.error(errMsg);
		}
		setLoading(false);
		if (response) {
			login(response);
			loadUser();
			navigate("/");
			return;
		}
		setLoading(false);
	};

	return (
		<div className="h-screen relative w-full bg-white flex justify-center items-center">
			<img src={Logo} alt="" className="absolute top-8 left-10" />
			<div>
				<img src={Illustration} alt="" className="mx-auto" />
				<h4 className="text-3xl font-semibold text-sec text-center">
					Log in to your account
				</h4>
				<p className="text-base mt-1 font-normal text-es-gray-100 text-center">
					Welcome back! Please enter your details.
				</p>
				<form className="mt-4" onSubmit={handleSubmit(onSubmit)}>
					<div className="space-y-4 w-96">
						<div>
							<Controller
								name="email"
								control={control}
								rules={{
									required: "This field is required",
									pattern: {
										value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
										message: "Invalid email format",
									},
								}}
								render={({ field: { value, onChange, name } }) => (
									<Input
										type="email"
										value={value}
										onChange={onChange}
										placeholder="Please Enter your email"
										label="Email"
										name={name}
									/>
								)}
							/>
							{errors.email && (
								<p className="text-[#dc2626] text-xs">{errors.email.message}</p>
							)}
						</div>
						<div>
							<Controller
								name="password"
								control={control}
								rules={{
									required: "This field is required",
									pattern: {
										value:
											/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^\w\s]).{8,}$/g,
										message:
											"Your password must have at least one uppercase letter, one lowercase letter, one digit, one special character, and a minimum length of 8 characters.",
									},
								}}
								render={({ field: { value, onChange, name } }) => (
									<Input
										type="password"
										value={value}
										onChange={onChange}
										name={name}
										label="Password"
										placeholder="**********"
									/>
								)}
							/>
							{errors.password && (
								<p className="text-[#dc2626] text-xs">
									{errors.password.message}
								</p>
							)}
						</div>
						<div className="flex justify-between items-center">
							<div className="flex gap-2 items-center">
								<input type="checkbox" name="" id="" />
								<label
									htmlFor=""
									className="text-sm font-medium text-es-gray-200">
									Remember for 30 days
								</label>
							</div>
							<p className="text-sm font-medium text-primary hidden">
								Forgot Password?
							</p>
						</div>
					</div>
					<div className="w-96 mt-7">
						<PrimaryBtn
							type="submit"
							loading={loading}
							width="w-96"
							text="Sign in"
						/>
					</div>
				</form>
			</div>
		</div>
	);
};

export default Login;
